import { useNavigation } from "../../../helpers/navigationHelpers";
import { ActiveWebsitePage } from "../../../types/ActiveWebsitePageEnum";
import styles from "./footer.module.css";

export const Footer = () => {
  const { navigateToPage } = useNavigation();

  return (
    <footer className={styles.footer}>
      <div className={styles.sky} aria-hidden="true" />

      <div className={styles.container}>
        <p className={styles.tagline}>
          <span>Samen kom je verder</span>
        </p>

        <div className={styles.bottom}>
          <div className={styles.left}>
            <img
              className={styles.logo}
              src="/logo/Opluchtpost - Logo RGB - Midres.png"
              alt="Opluchtpost"
              loading="lazy"
              decoding="async"
            />
            <div className={styles.contact}>
              <div className={styles.company}>Opluchtpost</div>
              <a className={styles.link} href="mailto:opluchtpost@gmail.com">
                Opluchtpost@gmail.com
              </a>
              {/* <a className={styles.link} href="tel:+31656255234">
                06 000 000 00
              </a> */}
            </div>
          </div>

          <div className={styles.right}>
            <a
              className={styles.disclaimer}
              href="/disclaimer"
              onClick={(e) => {
                e.preventDefault();
                navigateToPage(ActiveWebsitePage.Disclaimer);
              }}
            >
              Disclaimer
            </a>
            <div className={styles.copy}>© 2025 Opluchtpost</div>
          </div>
        </div>
      </div>
    </footer>
  );
};
